export default {
  namespaced: true,
  state: () => ({
    alertOpen: true
  }),
  getters: {
    isAlertOpen: (state) => state.alertOpen
  },
  mutations: {
    setIsAlertOpen: (state, isOpen) => {
      state.alertOpen = isOpen
    }
  },
  actions: {
    closeAlert({ commit }) {
      commit('setIsAlertOpen', false)
    }
  }
}
